import { Component } from 'react';

import NoImage from 'Lib/components/common/NoImage';

class Image extends Component {
    state = {
        isLoaded: false
    };

    onLoad = () => {
        if (this.props.onLoad) {
            this.props.onLoad();
        } else {
            this.setState({ isLoaded: true });
        }
    };

    render() {
        const { src, ...rest } = this.props;

        if (!src) return <NoImage width={this.props.width} />;
        return <img {...rest} src={src} onLoad={this.onLoad} />;
    }
}

export default Image;
